/**
 * AGI-309 — the `event` field notification-service stamps on every socket
 * notification. NotificationsSidebar dispatches on these to pick which toast
 * renders a given notification; a value not listed here renders nothing
 * rather than falling through to the wrong toast's fields.
 *
 * Must match the routing-key strings the backend actually publishes —
 * `calendar.event.reminder_triggered` (existing), `lead.appointment_notification.*`
 * (AGI-307, leads-service), `calendar.connection.*` (AGI-306,
 * agent-integrations-service).
 */
export const eNotificationEvent = {
  CALENDAR_EVENT_REMINDER_TRIGGERED: 'calendar.event.reminder_triggered',
  LEAD_APPOINTMENT_CREATED: 'lead.appointment_notification.created',
  LEAD_APPOINTMENT_MOVED: 'lead.appointment_notification.moved',
  LEAD_APPOINTMENT_CANCELLED: 'lead.appointment_notification.cancelled',
  CALENDAR_CONNECTION_REVOKED: 'calendar.connection.revoked',
  CALENDAR_CONNECTION_RESTORED: 'calendar.connection.restored',
  LEAD_HANDOFF_ASSIGNED: 'lead.handoff.assigned',
  SMARTLEADBOT_HANDOFF_UNATTENDED: 'smartleadbot.handoff.unattended',
} as const;

export type tNotificationEvent =
  (typeof eNotificationEvent)[keyof typeof eNotificationEvent];

// string[], not tNotificationEvent[]: these are checked against an incoming
// socket payload's `event`, which is untyped at the wire — a plain `string`
// can't be passed to `.includes()` on an array typed to the narrower union.
export const LEAD_APPOINTMENT_EVENTS: string[] = [
  eNotificationEvent.LEAD_APPOINTMENT_CREATED,
  eNotificationEvent.LEAD_APPOINTMENT_MOVED,
  eNotificationEvent.LEAD_APPOINTMENT_CANCELLED,
];

export const CALENDAR_CONNECTION_EVENTS: string[] = [
  eNotificationEvent.CALENDAR_CONNECTION_REVOKED,
  eNotificationEvent.CALENDAR_CONNECTION_RESTORED,
];

export const HANDOFF_EVENTS: string[] = [
  eNotificationEvent.LEAD_HANDOFF_ASSIGNED,
  eNotificationEvent.SMARTLEADBOT_HANDOFF_UNATTENDED,
];
